import { css } from 'styled-components';
import {
  ThemedFunctor, BreakpointQueryName, getSpacing, SpacingName, FontWeight, getTypography, TypographyName,
} from '@doveit/lego';

export const picture: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginRight(theme, SpacingName.SMALL)}
  width: 6rem;
  flex-shrink: 0;
  padding-left: 1px;

  img {
    width: 100%;
    border-radius: .625rem;
    background-color: ${theme.palettes.neutrals.lighter};
  }

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: 8.75rem;
    position: absolute;
    left: 0;
  }
`;

export const infoBox: ThemedFunctor = ({ theme }) => css`
  display: flex;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    margin-left: ${theme.spaceUnits.desktop.SMALL};
  }
`;

export const wrapper: ThemedFunctor = ({ theme }) => css`
  position: relative;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    padding-left: 8.75rem;
  }
`;

export const jobTitle: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.H4)}
  font-weight: ${FontWeight.BOLD};
`;

export const bio: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    margin-left: ${theme.spaceUnits.desktop.SMALL};
  }
`;

export const quote: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}
  ${getTypography(theme, TypographyName.H4)}
  font-style: italic;
  color: ${theme.palettes.neutrals.dark};
`;

export const link: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}
  ${getTypography(theme, TypographyName.H4)}
  color: ${theme.palettes.brand.primary};
`;
